/* tslint:disable */
/* eslint-disable */
/**
 * DynamicForms.Server | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StrapiBlockFromJSON, StrapiBlockToJSON, } from './StrapiBlock';
import { QuestionComponentFromJSON, QuestionComponentToJSON, } from './QuestionComponent';
/**
 * Check if a given object implements the StepComponent interface.
 */
export function instanceOfStepComponent(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('useFooter' in value) || value['useFooter'] === undefined)
        return false;
    if (!('questions' in value) || value['questions'] === undefined)
        return false;
    return true;
}
export function StepComponentFromJSON(json) {
    return StepComponentFromJSONTyped(json, false);
}
export function StepComponentFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'title': json['title'],
        'header': json['header'] == null ? undefined : (json['header'].map(StrapiBlockFromJSON)),
        'footer': json['footer'] == null ? undefined : (json['footer'].map(StrapiBlockFromJSON)),
        'useFooter': json['useFooter'],
        'questions': (json['questions'].map(QuestionComponentFromJSON)),
    };
}
export function StepComponentToJSON(json) {
    return StepComponentToJSONTyped(json, false);
}
export function StepComponentToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'title': value['title'],
        'header': value['header'] == null ? undefined : (value['header'].map(StrapiBlockToJSON)),
        'footer': value['footer'] == null ? undefined : (value['footer'].map(StrapiBlockToJSON)),
        'useFooter': value['useFooter'],
        'questions': (value['questions'].map(QuestionComponentToJSON)),
    };
}
